<template name="classdd">

  <Dropdown
    :options="classList"
    :selected="filteredClass"
    :title="'Class'"
    v-on:updateOption="updateFilteredClass"
    style="min-width: 12rem"
  ></Dropdown>
</template>

<script>
import { PupilService } from "@/services/pupil.service";
const Dropdown = () => import("@/components/Dropdown.vue");

export default {
  name: "classdd",
  props: {
    classSelected: { type: Object, required: false },
    presetNameOnly: {type: String, required: false }
  },
  components: {
    Dropdown,
  },
  computed: {
    classList() {
      return this.classesArray;
    },
    classInSelection() {
        return this.filteredClass
    }
  },
  data() {
    return {
      classesArray: [],
      filteredClass: {}
    };
  },
  created() {
    this.fetchClasses();
  },
  mounted() {
    if (this.classSelected != undefined) {
        this.filteredClass = this.classSelected
    }

  },
  watch: {
    classesArray(newValue) {
     this.updateFilteredClass(this.filteredClass);
    },
    classSelected(newValue) {
        if (newValue.id != undefined) {
            this.filteredClass = newValue
        } else {
            this.filteredClass = this.classesArray[0]
        }
       
    }
  },
  methods: {
    fetchClasses() {
      PupilService.getClasses()
        .then((response) => this.buildClassList(response.data.data))
        .catch((err) => {
          console.log("classes " + err);
          this.errored = true;
        });
    },
    buildClassList(data) {
      this.classesArray = data.map(function (item, index) {
        return { id: index + 1, name: item };
      });

      this.classesArray = [{ id: 0, name: "Showing All" }].concat(
        this.classesArray
      );
    },
    updateFilteredClass(value) {
      if (value === undefined || value.id === undefined ) {
          if (this.presetNameOnly != undefined ) {

                  let t = this.classesArray
                  .filter((tt) => {
                    return tt.name == this.presetNameOnly;
                  })
                  .shift();
                  
                  this.filteredClass = t
              } else {
                this.filteredClass = this.classesArray[0];
              }


       
      } else if (value.id != this.filteredClass.id) {
        this.filteredClass = value;
      }

      this.$emit("classValueChanged", this.filteredClass);
    },
  },
};
</script>